import { graphql } from ':src/graphql';

export const organizationProgramById = graphql(`
  query OrganizationProgramByIdQuery($organizationProgramId: String!) {
    organizationProgramById(organizationProgramId: $organizationProgramId) {
      id
      name
      requiresNotesInReports
      introCallPreferenceId
      requiresSupervisorAdminHours
      attributeOverrides {
        requiresSupervisorAdminHours
      }
    }
  }
`);

export const superviseesByOrganizationProgramId = graphql(`
  query SuperviseesByOrganizationProgramIdQuery(
    $organizationProgramId: String!
    $searchQuery: String
  ) {
    superviseesByOrganizationProgramId(
      organizationProgramId: $organizationProgramId
      searchQuery: $searchQuery
    ) {
      result {
        id
        firstName
        lastName
        fullName
        supervisorMatches {
          id
          supervisorId
          matchStatusId
        }
      }
      total
    }
  }
`);

export const organizationSupervisorsOutsideProgram = graphql(`
  query OrganizationSupervisorsOutsideProgramQuery(
    $matchStatusId: Int
    $limit: Int!
    $offset: Int!
    $searchQuery: String
    $programId: String
  ) {
    organizationSupervisors(
      matchStatusId: $matchStatusId
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
      programId: $programId
    ) {
      result {
        supervisor {
          id
          firstName
          lastName
          fullName
          superviseeMatches {
            id
            matchStatusId
          }
        }
      }
    }
  }
`);

export const organizationSuperviseesOutsideProgram = graphql(`
  query OrganizationSuperviseesOutsideProgram(
    $limit: Int!
    $offset: Int!
    $organizationId: Int!
    $filter: UsersByOrganizationIdQueryFilter
    $searchQuery: String
    $sortByMostRecentSession: Boolean
    $programId: String
  ) {
    usersByOrganizationId(
      limit: $limit
      offset: $offset
      organizationId: $organizationId
      filter: $filter
      searchQuery: $searchQuery
      sortByMostRecentSession: $sortByMostRecentSession
      programId: $programId
    ) {
      result {
        id
        firstName
        lastName
        fullName
        supervisorMatches {
          id
          supervisorId
          matchStatusId
        }
      }
      total
    }
  }
`);

export const organizationProgramDirectorsByOrganizationIdQuery = graphql(`
  query OrganizationProgramDirectorsByOrganizationIdQuery($organizationId: Int!) {
    organizationProgramDirectorsByOrganizationId(organizationId: $organizationId) {
      id
      firstName
      lastName
      fullName
      organizationPrograms {
        id
      }
    }
  }
`);
